module.exports = __webpack_public_path__ + "img/turk1.4dbed059.jpg";